<script setup lang="ts">
import { computed } from "vue";

import SVGWrapper from "./utils/SVGWrapper.vue";

import type { colorTag } from "@/Modules/App/Models/Styles/Colors";
import type { iconSize } from "@/Modules/App/Models/Styles/Icons";

export interface IconProps {
  size?: iconSize;
  color?: colorTag;
  background?: colorTag;
}

const props = withDefaults(defineProps<IconProps>(), { color: "content-high", size: "md" });

const colorClass = computed((): string => `fill-${props.color}`);
</script>

<template>
  <SVGWrapper :size="size" :background="background" viewBox="0 0 14 18">
    <path d="M11.375 8.97052V9.97052H2.62505V8.97052H11.375Z" :class="colorClass" />
    <path d="M8.44231 10.9704V11.9704H2.625V10.9704H8.44231Z" :class="colorClass" />
    <path d="M7.32679 13.9704V12.9704H2.63448V13.9704H7.32679Z" :class="colorClass" />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M0.75 0.666687H8.125L13.25 5.87257V17.3334H0.75V0.666687ZM11.5865 5.56865L8.44231 2.37257V5.56865H11.5865ZM1.71154 1.64708V16.353H12.2885V6.54904H7.48077V1.64708H1.71154Z"
      :class="colorClass"
    />
  </SVGWrapper>
</template>

<style scoped lang="scss"></style>
